import {Component, computed, input} from '@angular/core';
import {ImageFallbackDirective} from "../../../image-fallback.directive";
import {ProfileImageService} from "../profile-image.service";
import {NgIf} from "@angular/common";
import {ProfileImage, ProfileImageInitials, ProfileImageFallbackType} from "../model/profile";

@Component({
    selector: 'profile-image',
    templateUrl: './profile-image.component.html',
    imports: [
        ImageFallbackDirective,
        NgIf
    ],
    styleUrls: ['./profile-image.component.css']
})
export class ProfileImageComponent {
    image = input.required<ProfileImage>();

    path = computed(() => {
        if (this.image()?.imageName) {
            return this.imageService.getImagePath(this.image().imageName)
        } else {
            return null;
        }
    });

    fallback = computed(() => {
        if (this.image()?.fallback?.type == ProfileImageFallbackType.Initials) {
            return this.image().fallback as ProfileImageInitials
        } else {
            return null
        }
    });

    constructor(private imageService: ProfileImageService) {
    }
}
